// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import { initializeApp } from "firebase/app";
import { clientConfig } from "../config/clientConfig";

console.log("Using Firebase Project:", clientConfig.projectId);
console.log("Auth Domain:", clientConfig.authDomain);
console.log("API Key:", clientConfig.apiKey);

// Initialize Firebase
export const firebaseApp = initializeApp(clientConfig);
